import { withMotionMax } from '@hoc/withMotionMax';
import CardCarousel from '@stories/Components/CardCarousel/CardCarousel';
import MediaCard from '@stories/Components/MediaCard/MediaCard';
import * as React from 'react';
import S from './MediaCarousel.styles';
const MediaCarousel = ({ ...otherProps }) => {
    return (React.createElement(S.Wrapper, null,
        React.createElement(CardCarousel, { ...otherProps, renderItem: (item) => React.createElement(MediaCard, { ...item }) })));
};
export default withMotionMax(MediaCarousel);
